import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  profileHeaderRow: {
    width: '100%',
    minWidth: 0,
  },
  profileImageColumn: {
    flexShrink: 0,
  },
  profileInfo: {
    marginLeft: '15px',
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 1 0%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },
  /** Role row: full width; Edit button is absolutely positioned to the right (see {@link editButtonAnchor}). */
  roleRowWithEdit: {
    position: 'relative',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  editButtonAnchor: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 1,
  },
  /** Metadata column: always spans full width of {@link profileInfo}. */
  metaStack: {
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
  },
  profileImage: {
    height: '250px',
    width: '250px',
    borderRadius: '4%',
    overflow: 'hidden',
    display: 'inline-flex',
    [theme.breakpoints.down('sm')]: {
      height: '2.8em',
      width: '2.8em',
      borderRadius: '5%',
    },
    '& .MuiAvatar-root': {
      width: '100%',
      height: '100%',
    },
    '& .MuiAvatar-root img': {
      objectFit: 'cover',
    },
    backgroundColor: theme.palette.primary.light,
    fontSize: theme.typography.pxToRem(40),
  },
  profileInfoContainer: {
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
  },
  socialLinks: {
    width: '100%',
  },
  username: {
    wordBreak: 'break-all',
  },
  preferredUsername: {
    display: 'block',
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
  role: {
    /** Avoid breaking phrases like "editor-in-chief" at hyphens when the line wraps. */
    hyphens: 'none',
  },
  usernameBreakWordPolicy: {
    wordBreak: 'keep-all',
  },
  badgeGroupContainer: {
    display: 'inline-block',
  },
  badgeGroupInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  bioText: {
    maxWidth: '500px',
    textAlign: 'left',
    width: '100%',
  },
  button: {
    padding: theme.spacing(0, 2),
  },
}));
